import {AsyncPipe}                        from '@angular/common';
import {Component, input}                 from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MedsRecordLogIntf} from '@djsharkk/logr-types';
import {InputWrapperComponent}            from '../../../forms/input-wrapper/input-wrapper.component';
import {DialogEditBase}                   from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-meds',
			   imports: [
				   InputWrapperComponent,
				   ReactiveFormsModule,
				   FormsModule,
				   AsyncPipe
			   ],
			   templateUrl: './dialog-edit-meds.component.html',
			   styleUrl   : './dialog-edit-meds.component.css'
		   })
export class DialogEditMedsComponent extends DialogEditBase<MedsRecordLogIntf> {
	rec = input.required<MedsRecordLogIntf>();
}
